__turbopack_context__.v({
  "mainContainer": "PrizeRedemptionDescription-module__h1BGCq__mainContainer",
  "subtitle": "PrizeRedemptionDescription-module__h1BGCq__subtitle",
  "title": "PrizeRedemptionDescription-module__h1BGCq__title",
});
